module.exports = __webpack_public_path__ + "static/media/replied.29ac9040.png";